import {TabsProps} from "antd";
import {Tabs} from "components/common";
import React, {useEffect, useState} from "react";
import {tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import AllReport from "./AllReport/AllReport";
import DetailReport from "./DetailReport/DetailReport";
import {setSiderKey} from "redux/reducer/common";

const StoreReport: React.FC = () => {
  document.title = "Báo cáo kho";
  const id = useAppSelector(e => e.pending?.id);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSiderKey("baoCaoKho"));
  }, []);

  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.STORE_REPORT.ALL_REPORT,
      label: "Kho - sổ tổng hợp",
      children: <AllReport />,
    },
    {
      key: tabKeys.STORE_REPORT.DETAIL_REPORT,
      label: "Kho - sổ chi tiết",
      children: <DetailReport />,
    },
  ];
  return (
    <div className="revenues page">
      <div className="main">
        <Tabs activeKey={activeTab} items={itemsInit} />
      </div>
    </div>
  );
};

export default StoreReport;
